import constants from "./constants";
import { isColorOscuro } from "@/helpers/ColorHelper";
export function getEmergenciaColor(emergencia, predeterminado = '#000000') {
    return (emergencia?.ESTADOS?.[0]?.EMERGENCIA_ESTADO_TIPO?.COLOR ||
        predeterminado);
}
export const getLabelEstadoColor = (emergencia, predeterminado = '#000000') => {
    return isColorOscuro(getEmergenciaColor(emergencia, predeterminado))
        ? 'text-white'
        : 'text-dark';
};
export const getIconoTipoEmergencia = (tipoEmergenciaID) => {
    const incendios = [
        constants.maestras.TIPO_INCENDIO.FORESTAL.ID_EMERGENCIA_TIPO,
        constants.maestras.TIPO_INCENDIO.AGRICOLA.ID_EMERGENCIA_TIPO,
        constants.maestras.TIPO_INCENDIO.INTERFAZ.ID_EMERGENCIA_TIPO,
        constants.maestras.TIPO_INCENDIO.DESCONOCIDO.ID_EMERGENCIA_TIPO
    ];
    return incendios.includes(tipoEmergenciaID)
        ? require('@/assets/llama.svg')
        : require('@/assets/Evento.svg');
};
export const actualizarEmergencia = (emergencia, data) => {
    if (!emergencia || !data)
        return emergencia;
    const updated = {
        ...emergencia,
        ...data,
        EMERGENCIA_TIPO: {
            ...(emergencia.EMERGENCIA_TIPO),
            ID_EMERGENCIA_TIPO: data.ID_EMERGENCIA_TIPO
        },
        INCENDIO: emergencia.INCENDIO && data.INCENDIO
            ? { ...emergencia.INCENDIO, ...data.INCENDIO }
            : emergencia.INCENDIO
    };
    return updated;
};
export const getDirectorPrincipal = (emergencia) => {
    if (!emergencia)
        return null;
    const directores = emergencia.DIRECTOR_EXTINCION || [];
    return directores.find(d => d.PRINCIPAL) || null;
};
export const normalizeGraficos = (graficos = [], planId) => {
    let discarded = 0;
    for (let z = graficos.length - 1; z >= 0; z--) {
        const oldGrafico = graficos[z];
        try {
            const geometry = oldGrafico.GEOMETRIA
                ? JSON.parse(oldGrafico.GEOMETRIA)
                : oldGrafico.geometry;
            const symbol = oldGrafico.SIMBOLO
                ? JSON.parse(oldGrafico.SIMBOLO)
                : oldGrafico.symbol;
            const attributes = oldGrafico.ATRIBUTOS
                ? JSON.parse(oldGrafico.ATRIBUTOS)
                : oldGrafico.attributes;
            oldGrafico.geometry = geometry;
            oldGrafico.symbol = symbol;
            oldGrafico.attributes = attributes;
            oldGrafico.type = oldGrafico.TIPO
                ? oldGrafico.TIPO
                : oldGrafico.type;
            delete oldGrafico.GEOMETRIA;
            delete oldGrafico.SIMBOLO;
            delete oldGrafico.ATRIBUTOS;
            delete oldGrafico.TIPO;
        }
        catch (error) {
            console.warn(`Discarded corrupt graphic ${oldGrafico.ID_GRAFICO} from operations plan ${planId}`, error);
            graficos.splice(z, 1);
            discarded++;
        }
    }
    return discarded;
};
